export { padStart } from './padStart';
export { cleanText } from './textTools';
export { isAutoPlay } from './autoplay';
export { createCode, removePairStorage, loadPairStorage, loadUserStorage, saveUserStorage, resetUserPairing } from './pairCode';
export { Dictate, Transcription } from './dictate';
export { AudioObj as AudioTools } from './audioTools';
export { fetchAB, fetchArrayBuffer } from './buffer';
// export { setupVideoCache } from './preCache';
